import { render, staticRenderFns } from "./applyTui.vue?vue&type=template&id=22af1815&scoped=true&"
import script from "./applyTui.vue?vue&type=script&lang=js&"
export * from "./applyTui.vue?vue&type=script&lang=js&"
import style0 from "./applyTui.vue?vue&type=style&index=0&id=22af1815&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af1815",
  null
  
)

export default component.exports